'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage a state of a certain menu item
 * @param {CommonMenuItem} item
 * @constructor
 */
/**
 * @module navigation/menuStateManager
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function MenuStateManager(item) {
    this.item = item;
    this.itemKey = item.getTitle().toLowerCase();

    this.updateUrl();

    this.prevState = this.getItemState();
}

MenuStateManager.prototype.COOKIE_NAME = 'navigationState';
MenuStateManager.prototype.COOKIE_PATH = '/';
MenuStateManager.prototype.COOKIE_DURATION = 365;

/**
 * @public
 * @returns {Object|{}}
 */
MenuStateManager.prototype.getItemState = function () {
    var itemState = this.readData();

    return itemState && itemState[this.itemKey];
};

/**
 * @public
 * @param {Object} options
 * @returns {MenuStateManager}
 */
MenuStateManager.prototype.setItemState = function (options) {
    var state = this.readData() || {};
    state[this.itemKey] = state[this.itemKey] || {};

    _jquery2.default.extend(true, state[this.itemKey], options);

    this.writeData(state);

    this.updateUrl();

    return this;
};

/**
 * Check existing of state for menu item
 * @returns {boolean}
 */
MenuStateManager.prototype.hasItemState = function () {
    return !!this.readData();
};

/**
 * @public
 * @returns {MenuStateManager}
 */
MenuStateManager.prototype.clearItemState = function () {
    var itemState = this.readData();
    delete itemState[this.itemKey];

    this.writeData(itemState);

    this.updateUrl();

    return this;
};

/**
 * Read data from cookie
 * @protected
 * @returns {Object}
 */
MenuStateManager.prototype.readData = function () {
    var data = null;

    if (!_jsCookie2.default.get(this.COOKIE_NAME)) {
        return data;
    }

    try {
        data = JSON.parse(window.atob(_jsCookie2.default.get(this.COOKIE_NAME)));
    } catch (e) {
        throw new Error(e.name + ': ' + e.message + '\n' + e.stack);
    }

    return data;
};

/**
 * Write data to cookie
 * @protected
 * @param {Object} data
 */
MenuStateManager.prototype.writeData = function (data) {
    var self = this;

    try {
        this.prevState = this.getItemState();

        _jsCookie2.default.set(self.COOKIE_NAME, window.btoa((0, _stringify2.default)(data)), {
            path: self.COOKIE_PATH,
            domain: '.' + document.domain.split('.').slice(-2).join('.'),
            expires: self.COOKIE_DURATION
        });
    } catch (e) {
        throw new Error(e.name + ': ' + e.message + '\n' + e.stack);
    }
};

/**
 * Update url according to actual state
 * @protected
 */
MenuStateManager.prototype.updateUrl = function () {
    if (!this.hasItemState()) {
        return;
    }

    var $link = this.item.$obj.children(),
        url = $link.attr('href'),
        updatedUrlSuffix = this.buildUrlSuffix(this.getItemState());

    if (this.prevState) {
        url = url.replace(this.buildUrlSuffix(this.prevState), updatedUrlSuffix);
    } else {
        url += !/(#.*)|(\/)$/.test(url) ? '/' : '';
        url += updatedUrlSuffix;
    }

    $link.attr('href', url);
};

/**
 * Build url suffix using state object
 * @protected
 * @param {Object} state
 * @returns {string}
 */
MenuStateManager.prototype.buildUrlSuffix = function (state) {
    state = state || {};

    var urlSuffix = '';

    if (state.path) {
        urlSuffix += state.path;
    }

    if (state.params) {
        var params = [];
        for (var param in state.params) {
            if (state.params.hasOwnProperty(param)) {
                params.push(encodeURIComponent(param) + '=' + encodeURIComponent(state.params[param]));
            }
        }
        params = params.join('&');

        urlSuffix += '?' + params;
    }

    if (state.hash) {
        urlSuffix += '#' + state.hash;
    }

    return urlSuffix;
};

exports.default = MenuStateManager;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/menuStateManager.js
// module id = 2170
// module chunks = 1